import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  TextArea,
  Label,
  Button,
  Icon
} from 'semantic-ui-react'

const CardPatientPanelUX = (props: any) => {
    return(
      <div
        id="CardPatientPanelUX-div-0"
        style={{width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          id="CardPatientPanelUX-div-181"
          style={{"height":"30px","marginBottom":"-24px","position":"relative"}}>
          {props.buttonToggleTabMenu}
        </div>
        <div
          id="CardPatientPanelUX-div-212"
          style={{display: "flex", width : "100%", paddingTop: "35px", ...(!props.hasDebt && { display: "none" }) }}>
          {props.totalBalancePrice}
        </div>
        <div
          id="CardPatientPanelUX-div-3"
          style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px", height: "250px", width: "auto"}}>
          {props.profileImage}
        </div>
        <div
          id="CardPatientPanelUX-div-97">
          
          <div
            id="CardPatientPanelUX-div-99"
            style={{ display: "grid",alignItems: "center", marginTop:"-50px",float:'right'}}>
            
            <div
              id="CardPatientPanelUX-div-100"
              style={{display: props.adrList ?  "flex" : "none" ,justifyContent: "row", alignItems: "center", marginLeft:"40px"}}>
              
              <div
                id="CardPatientPanelUX-div-101"
                style={{padding: "2px"}}>
                {props.otherImage}
              </div>
              <div
                id="CardPatientPanelUX-div-102"
                style={{padding: "2px"}}>
                {props.foodImage}
              </div>
              <div
                id="CardPatientPanelUX-div-103"
                style={{padding: "2px"}}>
                {props.drugImage}
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardPatientPanelUX-div-53"
          style={{padding: "10px 10px 0px 10px",marginTop:"10px"}}>
          {props.statusAndAction}
        </div>
        <div
          id="CardPatientPanelUX-div-214"
          style={{ fontSize: "0.75rem", padding: "0px 13px 0px 35px", minWidth: "8.75rem", display: props.showCreateAppointment ? "grid":"none"}}>
          
          <Button
            color="blue"
            id="CardPatientPanel-Button-CreateAppointment"
            onClick={props.goToCreateAppointment}
            size="mini"
            style={{width:"100%"}}>
            
            <div
              id="CardPatientPanelUX-div-218"
              style={{display:"flex", gap:"10px",alignItems:"center"}}>
              
              <Icon
                id="CardPatientPanelUX-Icon-216"
                name="calendar alternate">
              </Icon>
              <div
                id="CardPatientPanelUX-div-217">
                {props.languageUX === "en" ? "Make an appointment" : "ทำนัดหมาย"}
              </div>
            </div>
          </Button>
        </div>
        <div
          id="CardPatientPanelUX-div-213"
          style={{...(props.actionButton&&{padding: "10px",marginTop:"10px"}), ...(props.hideTelemed && { display: "none"})}}>
          {props.actionButton}
        </div>
        <div
          id="CardPatientPanelUX-div-215"
          style={{display: props.showDentalHistory ? "":"none",padding: "0px 10px", marginTop:"10px"}}>
          
          <Button
            color="pink"
            disabled={!props.showDentalHistory}
            fluid={true}
            id="CardPatientPanel-Button-DentalHistory"
            onClick={props.goToDentalHistory}
            size="mini"
            style={{width:"100%"}}>
            <div
              id="CardPatientPanelUX-div-175"
              style={{display:"flex", gap:"20px",alignItems:"center"}}>
              
              <img
                id="CardPatientPanelUX-img-176"
                src="/static/images/tooth-icon.png"
                style={{width: "10px", marginRight: "4px",marginLeft:"2px"}}>
              </img>
              <label
                id="CardPatientPanelUX-label-177">
                {props.languageUX === "en" ? "Dental History" : "ประวัติทางทันตกรรม"}
              </label>
            </div>
          </Button>
        </div>
        <div
          className="--override-disabled --grey"
          id="CardPatientPanelUX-div-222"
          style={{"width":"100%","height":"100%" , position:"relative", "paddingLeft":"10px",paddingTop:"10px" }}>
          
          <div
            id="CardPatientPanelUX-div-228">
            
            <div
              id="CardPatientPanelUX-div-229"
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginRight: "12px" }}>
              
              <div
                id="CardPatientPanelUX-div-231"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                HN
              </div>
              <div
                id="CardPatientPanelUX-div-238">
                {props.chatDetail}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-230"
              style={{ display: "flex" }}>
              
              <div
                id="CardPatientPanelUX-div-374">
                
                <div
                  id="CardPatientPanelUX-div-383">
                  {props.hnNumber}
                </div>
                <div
                  id="CardPatientPanelUX-div-378"
                  style={{ display: "flex", position: "absolute", right: "5px", transform: "translateY(-105%)", }}>
                  
                  <div
                    id="CardPatientPanelUX-div-379"
                    style={{ marginTop: "3px", ...(!props.gender  && { display: "none" }) }}>
                    
                    <Icon
                      className="large"
                      color={props.gender === "Female" ? "pink"  : "blue"}
                      id="CardPatientPanelUX-Icon-382"
                      name={props.gender === "Female" ? "venus"  : "mars"}>
                    </Icon>
                  </div>
                  <div
                    id="CardPatientPanelUX-div-380"
                    style={{ ...(!props.isShowPregnancy && { display: "none"}) }}>
                    {props.pregnancyImage}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-233"
            style={{ ...( !props.selectedEncounter?.number && { display: "none" } ) }}>
            
            <div
              id="CardPatientPanelUX-div-234"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-236"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                EN / AN
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-235">
              
              <div
                id="CardPatientPanelUX-div-385">
                {props.encounterNumber}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-239">
            
            <div
              id="CardPatientPanelUX-div-240"
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "5px 12px 5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-242"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Name and Surname" : "ชื่อ - นามสกุล"}
              </div>
              <div
                id="CardPatientPanelUX-div-244">
                {props.oldNameIcon}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-241">
              
              <div
                id="CardPatientPanelUX-div-384">
                {props.patientName}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-286">
            
            <div
              id="CardPatientPanelUX-div-288"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-290"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Gender" : "เพศ"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-289">
              
              <div
                id="CardPatientPanelUX-div-386">
                {props.gender}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-416">
            
            <div
              id="CardPatientPanelUX-div-417"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-420"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Birthdate" : "วันเดือนปีเกิด"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-418">
              
              <div
                id="CardPatientPanelUX-div-419">
                {props.birthdate}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-287">
            
            <div
              id="CardPatientPanelUX-div-421"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-422"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Age" : "อายุ"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-426">
              
              <div
                id="CardPatientPanelUX-div-427">
                {props.age}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-256">
            
            <div
              id="CardPatientPanelUX-div-257"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-259"
                style={{ fontWeight: "bold", fontSize: "12px", marginRight: "12px", }}>
                {props.languageUX === "en" ? "Citizen ID / Passport No" : "หมายเลขบัตรประชาชน / เลขที่หนังสือเดินทาง"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-258">
              
              <div
                id="CardPatientPanelUX-div-388">
                {props.citizen_no}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-261">
            
            <div
              id="CardPatientPanelUX-div-262"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-264"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "E-mail" : "อีเมล"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-263">
              
              <div
                id="CardPatientPanelUX-div-389">
                {props.email}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-266">
            
            <div
              id="CardPatientPanelUX-div-267"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-269"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Phone Number" : "เบอร์โทร"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-268">
              
              <div
                id="CardPatientPanelUX-div-390">
                {props.tel_mobile}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-271"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-272"
              style={{ display: "flex", alignItems: "center", margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-274"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Rights" : "สิทธิการรักษาพยาบาล"}
              </div>
              <div
                id="CardPatientPanelUX-div-404"
                style={{ margin: "3px 5px 0px 5px" }}>
                {props.coverageImage}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-273">
              
              <div
                id="CardPatientPanelUX-div-391">
                {props.coverage}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-276"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-278"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-282"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Payer" : "ผู้ชำระเงิน"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-279">
              
              <div
                id="CardPatientPanelUX-div-392">
                {props.payer}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-277"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-280"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-283"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                สิทธิส่วนลด
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-281">
              
              <div
                id="CardPatientPanelUX-div-405">
                {props.discountPolicyCoverage}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-354"
            style={{display: "flex", width : "100%", margin: "10px 0px", ...( !props.ButtonSuspending && { display: "none" } )}}>
            
            <div
              id="CardPatientPanelUX-div-357">
              {props.telemed}
            </div>
            <div
              id="CardPatientPanelUX-div-358">
              {props.ButtonSuspending}
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-296"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-298"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-302"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Religion" : "ศาสนา"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-299">
              
              <div
                id="CardPatientPanelUX-div-393">
                {props.religion}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-297"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-300"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-303"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Landmarks" : "จุดสังเกต"}
              </div>
            </div>
            <div
              className="custom-textarea-wrapper"
              id="CardPatientPanelUX-div-301"
              style={{ fontSize: "12px", marginRight: "12px" }}>
              
              <TextArea
                disabled={true}
                id="CardPatientPanelUX-TextArea-306"
                value={props.remark}>
              </TextArea>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-307"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-310"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-312"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Checkout" : "Checkout"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-311">
              
              <div
                id="CardPatientPanelUX-div-394">
                {props.checkout}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-308"
            style={{ ...(props.isHiddenAssessmentMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-313"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-315"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Isolate Precaution" : "Isolate Precaution"}
              </div>
            </div>
            <div
              className="custom-textarea-wrapper"
              id="CardPatientPanelUX-div-314"
              style={{ fontSize: "11px", marginRight: "12px" }}>
              
              <TextArea
                disabled={true}
                id="CardPatientPanelUX-TextArea-322"
                rows={Array.isArray(props.isolatePrecautionData?.[0]) ? props.isolatePrecautionData?.[0].length : 1}
                value={props.isolatePrecautionData?.[1]}>
              </TextArea>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-309"
            style={{ ...(props.isHiddenAssessmentMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-316"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-318"
                style={{ fontWeight: "bold", fontSize: "12px", marginRight: "12px",  }}>
                {props.languageUX === "en" ? "Fall Risk Assessment" : "Fall Risk Assessment"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-317">
              
              <div
                id="CardPatientPanelUX-div-395">
                {props.fallRiskAssessment || "-"}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-323"
            style={{ ...(props.isHiddenPartialMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-326"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-328"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Note" : "หมายเหตุ"}
              </div>
            </div>
            <div
              className="custom-textarea-wrapper"
              id="CardPatientPanelUX-div-327"
              style={{ fontSize: "11px", marginRight: "12px" }}>
              
              <TextArea
                disabled={true}
                id="CardPatientPanelUX-TextArea-338"
                value={props.note || "-"}>
              </TextArea>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-324"
            style={{ ...(props.isHiddenAssessmentMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-329"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-331"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Smoking" : "สูบบุหรี่"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-330">
              
              <div
                id="CardPatientPanelUX-div-396">
                {props.tobacco || "-"}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-325"
            style={{ ...(props.isHiddenAssessmentMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-332"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-334"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Drink Alcohol" : "ดื่มสุรา"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-333">
              
              <div
                id="CardPatientPanelUX-div-397">
                {props.alcohol || "-"}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-339"
            style={{ ...(props.isHiddenAssessmentMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-342"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-350"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Risk of infection" : "เสี่ยงต่อการติดเชื้อ"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-343">
              
              <div
                id="CardPatientPanelUX-div-398">
                {props.mdrTriage || "-"}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-340"
            style={{ ...(props.isHiddenAssessmentMenu && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-344"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-349"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "History of drug use" : "ประวัติการใช้ สารเสพย์ติด"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-345">
              
              <div
                id="CardPatientPanelUX-div-400">
                {props.narcotic || "-"}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-341">
            
            <div
              id="CardPatientPanelUX-div-346"
              style={{ margin: "5px 0px" }}>
              
              <div
                id="CardPatientPanelUX-div-348"
                style={{ fontWeight: "bold", fontSize: "12px" }}>
                {props.languageUX === "en" ? "Primary language used for communication" : "ภาษาหลักที่ใช้ในการติดต่อ"}
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-347">
              
              <div
                id="CardPatientPanelUX-div-401">
                {props.patientLanguage}
              </div>
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-355">
            
            <div
              id="CardPatientPanelUX-div-359"
              style={{ margin: "10px 12px 5px 0px", }}>
              {props.buttonBuyerEncounter}
            </div>
          </div>
          <div
            id="CardPatientPanelUX-div-356"
            style={{ ...(props.hideTelemed && {display: "none"}) }}>
            
            <div
              id="CardPatientPanelUX-div-360"
              style={{ margin: "10px 12px 5px 0px", }}>
              {props.btnBindId}
            </div>
          </div>
        </div>
        <div
          id="CardPatientPanelUX-div-71"
          style={{padding:"5px", ...(props.isHiddenPartialMenu && {display: "none"})}}>
          
          <Button
            color="blue"
            id="CardPatientPanelUX-Button-172"
            onClick={props.goToEclinical}
            style={{width: "100%", margin: "10px 0px",...(!props.ENABLE_ECLINICAL&& {display: "none"})}}>
            {props.languageUX === "en" ? "E-clinical" : "อี-คลินิก"}
          </Button>
          <div
            id="CardPatientPanelUX-div-72"
            style={{position :"relative", display: "none"}}>
            
            <TextArea
              id="CardPatientPanelUX-TextArea-73"
              style={{ width: "100%", height: "100%" }}
              value={props?.selectedADR || ""}>
            </TextArea>
            <Label
              id="CardPatientPanelUX-Label-74"
              onClick={props?.OnADR}
              style={{position: "absolute",right:"3px",bottom:"9px"}}>
              {props.languageUX === "en" ? "ADR" : "ADR"}
            </Label>
          </div>
          <div
            id="CardPatientPanelUX-div-75"
            style={{position :"relative"}}>
            
            <TextArea
              id="CardPatientPanelUX-TextArea-76"
              style={{ width: "100%", height: "100%" }}
              value={props?.underlyingDisease || ""}>
            </TextArea>
            <Label
              id="CardPatientPanelUX-Label-78"
              onClick={ props?.OnUnderlyingDisease}
              style={{position: "absolute",right:"3px",bottom:"9px"}}>
              {props.languageUX === "en" ? "U/D" : "ยู/ดี"}
            </Label>
          </div>
          <div
            id="CardPatientPanelUX-div-79"
            style={{position :"relative"}}>
            
            <TextArea
              id="CardPatientPanelUX-TextArea-81"
              style={{ width: "100%", height: "100%" }}
              value={props?.labResult || ""}>
            </TextArea>
            <Label
              id="CardPatientPanelUX-Label-83"
              onClick={ props?.OnLab}
              style={{position: "absolute",right:"3px",bottom:"9px"}}>
              {props.languageUX === "en" ? "Lab" : "แล็บ"}
            </Label>
          </div>
          <div
            id="CardPatientPanelUX-div-80"
            style={{position :"relative"}}>
            
            <TextArea
              id="CardPatientPanelUX-TextArea-82"
              style={{ width: "100%", height: "100%" }}
              value={props?.vitalSign || ""}>
            </TextArea>
            <Label
              id="CardPatientPanelUX-Label-84"
              onClick={ props?.OnVitalSign}
              style={{position: "absolute",right:"3px",bottom:"9px"}}>
              {props.languageUX === "en" ? "V/S" : "วี/เอส"}
            </Label>
          </div>
          <div
            className="--override-disabled --grey"
            id="CardPatientPanelUX-div-361"
            style={{ display: "flex" }}>
            
            <div
              id="CardPatientPanelUX-div-362"
              style={{ width: "50%" }}>
              
              <div
                id="CardPatientPanelUX-div-364"
                style={{ margin: "5px 0px" }}>
                
                <div
                  id="CardPatientPanelUX-div-370"
                  style={{ fontWeight: "bold", fontSize: "12px" }}>
                  {props.languageUX === "en" ? "Weight" : "น้ำหนัก"}
                </div>
              </div>
              <div
                id="CardPatientPanelUX-div-365"
                style={{ width: "90%",  }}>
                
                <div
                  id="CardPatientPanelUX-div-402">
                  {props?.weigth}
                </div>
              </div>
            </div>
            <div
              id="CardPatientPanelUX-div-363"
              style={{ width: "50%" }}>
              
              <div
                id="CardPatientPanelUX-div-366"
                style={{ margin: "5px 0px" }}>
                
                <div
                  id="CardPatientPanelUX-div-368"
                  style={{ fontWeight: "bold", fontSize: "12px" }}>
                  {props.languageUX === "en" ? "Height" : "ส่วนสูง"}
                </div>
              </div>
              <div
                id="CardPatientPanelUX-div-367"
                style={{ width: "90%",  }}>
                
                <div
                  id="CardPatientPanelUX-div-403">
                  {props?.height}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardPatientPanelUX-div-104">
          
          <div
            id="CardPatientPanelUX-div-105">
            {props.modalDrug}
          </div>
          <div
            id="CardPatientPanelUX-div-106">
            {props.modalFood}
          </div>
          <div
            id="CardPatientPanelUX-div-107">
            {props.modalOther}
          </div>
          <div
            id="CardPatientPanelUX-div-168">
            {props.modalKDA}
          </div>
          <div
            id="CardPatientPanelUX-div-169">
            {props.modalKFA}
          </div>
          <div
            id="CardPatientPanelUX-div-170">
            {props.modalKOA}
          </div>
        </div>
        <div
          id="CardPatientPanelUX-div-373"
          style={{ marginBottom: "50px" }}>
          
        </div>
      </div>
    )
}


export default CardPatientPanelUX

export const screenPropsDefault = {"hn":"1234","patientImage":"https://www.gannett-cdn.com/presto/2022/02/27/USAT/1846e15e-f386-491c-9b5a-e6f9f6ace1e1-AP_Russia_Space_Putin.jpg?crop=3884,2913,x0,y0&quality=50&width=640","patientName":"วลาดิเมีย ปูติน","profileImage":"[Profile Image]","telemed":"[O]"}

/* Date Time : Tue Oct 21 2025 04:15:15 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", display: \"flex\", flexDirection: \"column\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.profileImage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", alignItems: \"center\", padding: \"10px\", height: \"250px\", width: \"auto\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.statusAndAction"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\",marginTop:\"10px\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"5px\", ...(props.isHiddenPartialMenu && {display: \"none\"})}"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{position :\"relative\", display: \"none\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "TextArea",
      "parent": 72,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-73"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedADR || \"\""
        }
      },
      "seq": 73,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "ADR",
          "valueEN": "ADR"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Label-74"
        },
        "onClick": {
          "type": "code",
          "value": "props?.OnADR"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",right:\"3px\",bottom:\"9px\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{position :\"relative\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "TextArea",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-76"
        },
        "onBlur": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props?.underlyingDisease || \"\""
        }
      },
      "seq": 76,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "ยู/ดี",
          "valueEN": "U/D"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Label-78"
        },
        "onClick": {
          "type": "code",
          "value": " props?.OnUnderlyingDisease"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",right:\"3px\",bottom:\"9px\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{position :\"relative\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{position :\"relative\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "TextArea",
      "parent": 79,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-81"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props?.labResult || \"\""
        }
      },
      "seq": 81,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "TextArea",
      "parent": 80,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-82"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props?.vitalSign || \"\""
        }
      },
      "seq": 82,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "แล็บ",
          "valueEN": "Lab"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Label-83"
        },
        "onClick": {
          "type": "code",
          "value": " props?.OnLab"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",right:\"3px\",bottom:\"9px\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "วี/เอส",
          "valueEN": "V/S"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Label-84"
        },
        "onClick": {
          "type": "code",
          "value": " props?.OnVitalSign"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\",right:\"3px\",bottom:\"9px\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Button",
      "parent": 214,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "icon": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanel-Button-CreateAppointment"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.goToCreateAppointment"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-97"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"grid\",alignItems: \"center\", marginTop:\"-50px\",float:'right'}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{display: props.adrList ?  \"flex\" : \"none\" ,justifyContent: \"row\", alignItems: \"center\", marginLeft:\"40px\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "code",
          "value": "props.otherImage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"2px\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "code",
          "value": "props.foodImage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"2px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugImage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"2px\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-104"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalDrug"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-105"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalFood"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-106"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalOther"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalKDA"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-168"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalKFA"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-169"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalKOA"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-170"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "Button",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "อี-คลินิก",
          "valueEN": "E-clinical"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Button-172"
        },
        "onClick": {
          "type": "code",
          "value": "props.goToEclinical"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"10px 0px\",...(!props.ENABLE_ECLINICAL&& {display: \"none\"})}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "Button",
      "parent": 215,
      "props": {
        "color": {
          "type": "value",
          "value": "pink"
        },
        "disabled": {
          "type": "code",
          "value": "!props.showDentalHistory"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanel-Button-DentalHistory"
        },
        "onClick": {
          "type": "code",
          "value": "props.goToDentalHistory"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", gap:\"20px\",alignItems:\"center\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "img",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-img-176"
        },
        "src": {
          "type": "value",
          "value": "/static/images/tooth-icon.png"
        },
        "style": {
          "type": "code",
          "value": "{width: \"10px\", marginRight: \"4px\",marginLeft:\"2px\"}"
        }
      },
      "seq": 176,
      "void": true
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติทางทันตกรรม",
          "valueEN": "Dental History"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-label-177"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonToggleTabMenu"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{\"height\":\"30px\",\"marginBottom\":\"-24px\",\"position\":\"relative\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 212,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalBalancePrice"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-212"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width : \"100%\", paddingTop: \"35px\", ...(!props.hasDebt && { display: \"none\" }) }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.actionButton"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-213"
        },
        "style": {
          "type": "code",
          "value": "{...(props.actionButton&&{padding: \"10px\",marginTop:\"10px\"}), ...(props.hideTelemed && { display: \"none\"})}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-214"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"0.75rem\", padding: \"0px 13px 0px 35px\", minWidth: \"8.75rem\", display: props.showCreateAppointment ? \"grid\":\"none\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-215"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showDentalHistory ? \"\":\"none\",padding: \"0px 10px\", marginTop:\"10px\"}"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "Icon",
      "parent": 218,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Icon-216"
        },
        "name": {
          "type": "value",
          "value": "calendar alternate"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "div",
      "parent": 218,
      "props": {
        "children": {
          "type": "value",
          "value": "ทำนัดหมาย",
          "valueEN": "Make an appointment"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-217"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": null,
      "id": 218,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-218"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", gap:\"10px\",alignItems:\"center\"}"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": null,
      "id": 222,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-222"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\" , position:\"relative\", \"paddingLeft\":\"10px\",paddingTop:\"10px\" }"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-228"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 229,
      "name": "div",
      "parent": 228,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-229"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", marginRight: \"12px\" }"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 228,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-230"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": null,
      "id": 231,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-231"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 233,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-233"
        },
        "style": {
          "type": "code",
          "value": "{ ...( !props.selectedEncounter?.number && { display: \"none\" } ) }"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 234,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-234"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 235,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-235"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 234,
      "props": {
        "children": {
          "type": "value",
          "value": "EN / AN"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-236"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": null,
      "id": 238,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "code",
          "value": "props.chatDetail"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-238"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-239"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-240"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", margin: \"5px 12px 5px 0px\" }"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-241"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - นามสกุล",
          "valueEN": "Name and Surname"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-242"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "div",
      "parent": 240,
      "props": {
        "children": {
          "type": "code",
          "value": "props.oldNameIcon"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-244"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-256"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 256,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-257"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 256,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-258"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 257,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขบัตรประชาชน / เลขที่หนังสือเดินทาง",
          "valueEN": "Citizen ID / Passport No"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-259"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\", marginRight: \"12px\", }"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-261"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "div",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-262"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "div",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-263"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": null,
      "id": 264,
      "name": "div",
      "parent": 262,
      "props": {
        "children": {
          "type": "value",
          "value": "อีเมล",
          "valueEN": "E-mail"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-264"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-266"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-267"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "div",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-268"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "div",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": "เบอร์โทร",
          "valueEN": "Phone Number"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-269"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 271,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-271"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 272,
      "name": "div",
      "parent": 271,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-272"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", margin: \"5px 0px\" }"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": null,
      "id": 273,
      "name": "div",
      "parent": 271,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-273"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 272,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิการรักษาพยาบาล",
          "valueEN": "Rights"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-274"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": null,
      "id": 276,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-276"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-277"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "div",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-278"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 279,
      "name": "div",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-279"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 280,
      "name": "div",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-280"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "div",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-281"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "div",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ชำระเงิน",
          "valueEN": "Payer"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-282"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": null,
      "id": 283,
      "name": "div",
      "parent": 280,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิส่วนลด"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-283"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-286"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 287,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-287"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 286,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-288"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "div",
      "parent": 286,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-289"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 288,
      "props": {
        "children": {
          "type": "value",
          "value": "เพศ",
          "valueEN": "Gender"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-290"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": null,
      "id": 296,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-296"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-297"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 308,
      "void": false
    },
    {
      "from": null,
      "id": 298,
      "name": "div",
      "parent": 296,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-298"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": null,
      "id": 299,
      "name": "div",
      "parent": 296,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-299"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 300,
      "name": "div",
      "parent": 297,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-300"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "div",
      "parent": 297,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "custom-textarea-wrapper"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-301"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"12px\", marginRight: \"12px\" }"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "div",
      "parent": 298,
      "props": {
        "children": {
          "type": "value",
          "value": "ศาสนา",
          "valueEN": "Religion"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-302"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": null,
      "id": 303,
      "name": "div",
      "parent": 300,
      "props": {
        "children": {
          "type": "value",
          "value": "จุดสังเกต",
          "valueEN": "Landmarks"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-303"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 303,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 306,
      "name": "TextArea",
      "parent": 301,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-306"
        },
        "value": {
          "type": "code",
          "value": "props.remark"
        }
      },
      "seq": 306,
      "void": true
    },
    {
      "from": null,
      "id": 307,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-307"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": null,
      "id": 308,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-308"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenAssessmentMenu && {display: \"none\"}) }"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": null,
      "id": 309,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-309"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenAssessmentMenu && {display: \"none\"}) }"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": null,
      "id": 310,
      "name": "div",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-310"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": null,
      "id": 311,
      "name": "div",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-311"
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": null,
      "id": 312,
      "name": "div",
      "parent": 310,
      "props": {
        "children": {
          "type": "value",
          "value": "Checkout",
          "valueEN": "Checkout"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-312"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": null,
      "id": 313,
      "name": "div",
      "parent": 308,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-313"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": null,
      "id": 314,
      "name": "div",
      "parent": 308,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "custom-textarea-wrapper"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-314"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"11px\", marginRight: \"12px\" }"
        }
      },
      "seq": 314,
      "void": false
    },
    {
      "from": null,
      "id": 315,
      "name": "div",
      "parent": 313,
      "props": {
        "children": {
          "type": "value",
          "value": "Isolate Precaution",
          "valueEN": "Isolate Precaution"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-315"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": null,
      "id": 316,
      "name": "div",
      "parent": 309,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-316"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": null,
      "id": 317,
      "name": "div",
      "parent": 309,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-317"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": null,
      "id": 318,
      "name": "div",
      "parent": 316,
      "props": {
        "children": {
          "type": "value",
          "value": "Fall Risk Assessment",
          "valueEN": "Fall Risk Assessment"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-318"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\", marginRight: \"12px\",  }"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 322,
      "name": "TextArea",
      "parent": 314,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-322"
        },
        "rows": {
          "type": "code",
          "value": "Array.isArray(props.isolatePrecautionData?.[0]) ? props.isolatePrecautionData?.[0].length : 1"
        },
        "value": {
          "type": "code",
          "value": "props.isolatePrecautionData?.[1]"
        }
      },
      "seq": 322,
      "void": true
    },
    {
      "from": null,
      "id": 323,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-323"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenPartialMenu && {display: \"none\"}) }"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": null,
      "id": 324,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-324"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenAssessmentMenu && {display: \"none\"}) }"
        }
      },
      "seq": 339,
      "void": false
    },
    {
      "from": null,
      "id": 325,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-325"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenAssessmentMenu && {display: \"none\"}) }"
        }
      },
      "seq": 340,
      "void": false
    },
    {
      "from": null,
      "id": 326,
      "name": "div",
      "parent": 323,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-326"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 326,
      "void": false
    },
    {
      "from": null,
      "id": 327,
      "name": "div",
      "parent": 323,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "custom-textarea-wrapper"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-327"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"11px\", marginRight: \"12px\" }"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": null,
      "id": 328,
      "name": "div",
      "parent": 326,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "Note"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-328"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": null,
      "id": 329,
      "name": "div",
      "parent": 324,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-329"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 329,
      "void": false
    },
    {
      "from": null,
      "id": 330,
      "name": "div",
      "parent": 324,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-330"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": null,
      "id": 331,
      "name": "div",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "สูบบุหรี่",
          "valueEN": "Smoking"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-331"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 331,
      "void": false
    },
    {
      "from": null,
      "id": 332,
      "name": "div",
      "parent": 325,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-332"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 332,
      "void": false
    },
    {
      "from": null,
      "id": 333,
      "name": "div",
      "parent": 325,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-333"
        }
      },
      "seq": 333,
      "void": false
    },
    {
      "from": null,
      "id": 334,
      "name": "div",
      "parent": 332,
      "props": {
        "children": {
          "type": "value",
          "value": "ดื่มสุรา",
          "valueEN": "Drink Alcohol"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-334"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 334,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 338,
      "name": "TextArea",
      "parent": 327,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-TextArea-338"
        },
        "value": {
          "type": "code",
          "value": "props.note || \"-\""
        }
      },
      "seq": 338,
      "void": true
    },
    {
      "from": null,
      "id": 339,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-339"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenAssessmentMenu && {display: \"none\"}) }"
        }
      },
      "seq": 341,
      "void": false
    },
    {
      "from": null,
      "id": 340,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-340"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isHiddenAssessmentMenu && {display: \"none\"}) }"
        }
      },
      "seq": 354,
      "void": false
    },
    {
      "from": null,
      "id": 341,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-341"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 355,
      "void": false
    },
    {
      "from": null,
      "id": 342,
      "name": "div",
      "parent": 339,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-342"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 342,
      "void": false
    },
    {
      "from": null,
      "id": 343,
      "name": "div",
      "parent": 339,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-343"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": null,
      "id": 344,
      "name": "div",
      "parent": 340,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-344"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": null,
      "id": 345,
      "name": "div",
      "parent": 340,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-345"
        }
      },
      "seq": 345,
      "void": false
    },
    {
      "from": null,
      "id": 346,
      "name": "div",
      "parent": 341,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-346"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 346,
      "void": false
    },
    {
      "from": null,
      "id": 347,
      "name": "div",
      "parent": 341,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-347"
        }
      },
      "seq": 347,
      "void": false
    },
    {
      "from": null,
      "id": 348,
      "name": "div",
      "parent": 346,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาษาหลักที่ใช้ในการติดต่อ",
          "valueEN": "Primary language used for communication"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-348"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 348,
      "void": false
    },
    {
      "from": null,
      "id": 349,
      "name": "div",
      "parent": 344,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการใช้ สารเสพย์ติด",
          "valueEN": "History of drug use"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-349"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 349,
      "void": false
    },
    {
      "from": null,
      "id": 350,
      "name": "div",
      "parent": 342,
      "props": {
        "children": {
          "type": "value",
          "value": "เสี่ยงต่อการติดเชื้อ",
          "valueEN": "Risk of infection"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-350"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 350,
      "void": false
    },
    {
      "from": null,
      "id": 354,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-354"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width : \"100%\", margin: \"10px 0px\", ...( !props.ButtonSuspending && { display: \"none\" } )}"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": null,
      "id": 355,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-355"
        }
      },
      "seq": 356,
      "void": false
    },
    {
      "from": null,
      "id": 356,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-356"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.hideTelemed && {display: \"none\"}) }"
        }
      },
      "seq": 416,
      "void": false
    },
    {
      "from": null,
      "id": 357,
      "name": "div",
      "parent": 354,
      "props": {
        "children": {
          "type": "code",
          "value": "props.telemed"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-357"
        }
      },
      "seq": 357,
      "void": false
    },
    {
      "from": null,
      "id": 358,
      "name": "div",
      "parent": 354,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSuspending"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-358"
        }
      },
      "seq": 358,
      "void": false
    },
    {
      "from": null,
      "id": 359,
      "name": "div",
      "parent": 355,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonBuyerEncounter"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-359"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 12px 5px 0px\", }"
        }
      },
      "seq": 359,
      "void": false
    },
    {
      "from": null,
      "id": 360,
      "name": "div",
      "parent": 356,
      "props": {
        "children": {
          "type": "code",
          "value": "props.btnBindId"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-360"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 12px 5px 0px\", }"
        }
      },
      "seq": 360,
      "void": false
    },
    {
      "from": null,
      "id": 361,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-361"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 361,
      "void": false
    },
    {
      "from": null,
      "id": 362,
      "name": "div",
      "parent": 361,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-362"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 362,
      "void": false
    },
    {
      "from": null,
      "id": 363,
      "name": "div",
      "parent": 361,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-363"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 363,
      "void": false
    },
    {
      "from": null,
      "id": 364,
      "name": "div",
      "parent": 362,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-364"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 364,
      "void": false
    },
    {
      "from": null,
      "id": 365,
      "name": "div",
      "parent": 362,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-365"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"90%\",  }"
        }
      },
      "seq": 365,
      "void": false
    },
    {
      "from": null,
      "id": 366,
      "name": "div",
      "parent": 363,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-366"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 366,
      "void": false
    },
    {
      "from": null,
      "id": 367,
      "name": "div",
      "parent": 363,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-367"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"90%\",  }"
        }
      },
      "seq": 367,
      "void": false
    },
    {
      "from": null,
      "id": 368,
      "name": "div",
      "parent": 366,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนสูง",
          "valueEN": "Height"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-368"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 368,
      "void": false
    },
    {
      "from": null,
      "id": 370,
      "name": "div",
      "parent": 364,
      "props": {
        "children": {
          "type": "value",
          "value": "น้ำหนัก",
          "valueEN": "Weight"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-370"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 370,
      "void": false
    },
    {
      "from": null,
      "id": 373,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-373"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"50px\" }"
        }
      },
      "seq": 373,
      "void": false
    },
    {
      "from": null,
      "id": 374,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-374"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 374,
      "void": false
    },
    {
      "from": null,
      "id": 378,
      "name": "div",
      "parent": 374,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-378"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", position: \"absolute\", right: \"5px\", transform: \"translateY(-105%)\", }"
        }
      },
      "seq": 383,
      "void": false
    },
    {
      "from": null,
      "id": 379,
      "name": "div",
      "parent": 378,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-379"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"3px\", ...(!props.gender  && { display: \"none\" }) }"
        }
      },
      "seq": 379,
      "void": false
    },
    {
      "from": null,
      "id": 380,
      "name": "div",
      "parent": 378,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pregnancyImage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-380"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.isShowPregnancy && { display: \"none\"}) }"
        }
      },
      "seq": 381,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 382,
      "name": "Icon",
      "parent": 379,
      "props": {
        "className": {
          "type": "value",
          "value": "large"
        },
        "color": {
          "type": "code",
          "value": "props.gender === \"Female\" ? \"pink\"  : \"blue\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-Icon-382"
        },
        "name": {
          "type": "code",
          "value": "props.gender === \"Female\" ? \"venus\"  : \"mars\""
        }
      },
      "seq": 382,
      "void": false
    },
    {
      "from": null,
      "id": 383,
      "name": "div",
      "parent": 374,
      "props": {
        "children": {
          "type": "code",
          "value": "props.hnNumber"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-383"
        }
      },
      "seq": 378,
      "void": false
    },
    {
      "from": null,
      "id": 384,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientName"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-384"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 385,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "code",
          "value": "props.encounterNumber"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-385"
        }
      },
      "seq": 385,
      "void": false
    },
    {
      "from": null,
      "id": 386,
      "name": "div",
      "parent": 289,
      "props": {
        "children": {
          "type": "code",
          "value": "props.gender"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-386"
        }
      },
      "seq": 386,
      "void": false
    },
    {
      "from": null,
      "id": 388,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "code",
          "value": "props.citizen_no"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-388"
        }
      },
      "seq": 388,
      "void": false
    },
    {
      "from": null,
      "id": 389,
      "name": "div",
      "parent": 263,
      "props": {
        "children": {
          "type": "code",
          "value": "props.email"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-389"
        }
      },
      "seq": 389,
      "void": false
    },
    {
      "from": null,
      "id": 390,
      "name": "div",
      "parent": 268,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tel_mobile"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-390"
        }
      },
      "seq": 390,
      "void": false
    },
    {
      "from": null,
      "id": 391,
      "name": "div",
      "parent": 273,
      "props": {
        "children": {
          "type": "code",
          "value": "props.coverage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-391"
        }
      },
      "seq": 391,
      "void": false
    },
    {
      "from": null,
      "id": 392,
      "name": "div",
      "parent": 279,
      "props": {
        "children": {
          "type": "code",
          "value": "props.payer"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-392"
        }
      },
      "seq": 392,
      "void": false
    },
    {
      "from": null,
      "id": 393,
      "name": "div",
      "parent": 299,
      "props": {
        "children": {
          "type": "code",
          "value": "props.religion"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-393"
        }
      },
      "seq": 393,
      "void": false
    },
    {
      "from": null,
      "id": 394,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "code",
          "value": "props.checkout"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-394"
        }
      },
      "seq": 394,
      "void": false
    },
    {
      "from": null,
      "id": 395,
      "name": "div",
      "parent": 317,
      "props": {
        "children": {
          "type": "code",
          "value": "props.fallRiskAssessment || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-395"
        }
      },
      "seq": 395,
      "void": false
    },
    {
      "from": null,
      "id": 396,
      "name": "div",
      "parent": 330,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tobacco || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-396"
        }
      },
      "seq": 396,
      "void": false
    },
    {
      "from": null,
      "id": 397,
      "name": "div",
      "parent": 333,
      "props": {
        "children": {
          "type": "code",
          "value": "props.alcohol || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-397"
        }
      },
      "seq": 397,
      "void": false
    },
    {
      "from": null,
      "id": 398,
      "name": "div",
      "parent": 343,
      "props": {
        "children": {
          "type": "code",
          "value": "props.mdrTriage || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-398"
        }
      },
      "seq": 398,
      "void": false
    },
    {
      "from": null,
      "id": 400,
      "name": "div",
      "parent": 345,
      "props": {
        "children": {
          "type": "code",
          "value": "props.narcotic || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-400"
        }
      },
      "seq": 400,
      "void": false
    },
    {
      "from": null,
      "id": 401,
      "name": "div",
      "parent": 347,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientLanguage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-401"
        }
      },
      "seq": 401,
      "void": false
    },
    {
      "from": null,
      "id": 402,
      "name": "div",
      "parent": 365,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.weigth"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-402"
        }
      },
      "seq": 402,
      "void": false
    },
    {
      "from": null,
      "id": 403,
      "name": "div",
      "parent": 367,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.height"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-403"
        }
      },
      "seq": 403,
      "void": false
    },
    {
      "from": null,
      "id": 404,
      "name": "div",
      "parent": 272,
      "props": {
        "children": {
          "type": "code",
          "value": "props.coverageImage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-404"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"3px 5px 0px 5px\" }"
        }
      },
      "seq": 404,
      "void": false
    },
    {
      "from": null,
      "id": 405,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "code",
          "value": "props.discountPolicyCoverage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-405"
        }
      },
      "seq": 405,
      "void": false
    },
    {
      "from": null,
      "id": 416,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-416"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 417,
      "name": "div",
      "parent": 416,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-417"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 417,
      "void": false
    },
    {
      "from": null,
      "id": 418,
      "name": "div",
      "parent": 416,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-418"
        }
      },
      "seq": 418,
      "void": false
    },
    {
      "from": null,
      "id": 419,
      "name": "div",
      "parent": 418,
      "props": {
        "children": {
          "type": "code",
          "value": "props.birthdate"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-419"
        }
      },
      "seq": 419,
      "void": false
    },
    {
      "from": null,
      "id": 420,
      "name": "div",
      "parent": 417,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเดือนปีเกิด",
          "valueEN": "Birthdate"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-420"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 420,
      "void": false
    },
    {
      "from": null,
      "id": 421,
      "name": "div",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-421"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 0px\" }"
        }
      },
      "seq": 421,
      "void": false
    },
    {
      "from": null,
      "id": 422,
      "name": "div",
      "parent": 421,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ",
          "valueEN": "Age"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-422"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"12px\" }"
        }
      },
      "seq": 422,
      "void": false
    },
    {
      "from": null,
      "id": 426,
      "name": "div",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-426"
        }
      },
      "seq": 426,
      "void": false
    },
    {
      "from": null,
      "id": 427,
      "name": "div",
      "parent": 426,
      "props": {
        "children": {
          "type": "code",
          "value": "props.age"
        },
        "id": {
          "type": "value",
          "value": "CardPatientPanelUX-div-427"
        }
      },
      "seq": 427,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardPatientPanelUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "hn": "1234",
    "patientImage": "https://www.gannett-cdn.com/presto/2022/02/27/USAT/1846e15e-f386-491c-9b5a-e6f9f6ace1e1-AP_Russia_Space_Putin.jpg?crop=3884,2913,x0,y0&quality=50&width=640",
    "patientName": "วลาดิเมีย ปูติน",
    "profileImage": "[Profile Image]",
    "telemed": "[O]"
  },
  "width": 15
}

*********************************************************************************** */
